import {
  Grid,
  makeStyles, Paper,
  TextField,
  Typography
} from "@material-ui/core";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import Textarea from "../../Common/Textarea";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 40,
    marginBottom: 40
  },
  title: {
    ...theme.typography.subtitle2,
    marginBottom: 20
  }
}));

const Info = ({ t, onChangeData, role }) => {
  const classes = useStyles();
  const [value, setValue] = useState({});

  useEffect(() => {
  }, []);

  useEffect(() => {
    onChangeData(value);
  }, [value]);

  const fillRole = (items) => {
    setValue({
      nameRole: items.name,
      descriptionRole: items.description,
    });
  };

  useEffect(() => {
    if (!isEmpty(role)) {
      fillRole(role);
    }
  }, [role]);

  const handleChange = (event) => {
    setValue({ ...value, [event.target.name]: event.target.value });
  };

  return (
    <Paper elevation={1} className={classes.root}>
      <Typography className={classes.title}>
        {t("forms.role.info")}
      </Typography>
      <Grid container spacing={3}>
        <Grid item md={6} lg={6} xs={12}>
          <TextField
            name="nameRole"
            id="nameRole"
            onChange={handleChange}
            value={value.nameRole || ""}
            error={!value.nameRole}
            required
            label={t("forms.role.nameRole")}
            autoComplete='off'
            fullWidth
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12}>
          <Textarea
            name="descriptionRole"
            id="descriptionRole"
            onChange={handleChange}
            value={value.descriptionRole || ""}
            error={!value.descriptionRole}
            required
            label={t("forms.role.descriptionRole")}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default withTranslation()(Info);
